define([
	"csi/def",
	"csi/def/ActionFactory",
	"./ActionImage"
], function(def,ActionFactory,ActionImage) {

	return ActionFactory.declare("imageDefault", ActionImage, {
		constructor: function(xml) {
			this.m_id = "PropertyImageDefault";
			this.m_class = "iconImageDefault";
			this.m_typeControl = def.ACTION_ICON;
		},
		
		hasAccess: function(/*Context*/ctx) {
			// summary: enable only if the current image is not already the default
			return ctx.view.getCurrentImageKey() && !ctx.view.isCurrentImageDefault() && this.inherited(arguments);
		}
	});
});